
import { gql } from 'apollo-boost';

export const CREATE_TRACKING_EVENT = gql`
  mutation CreateTrackingEvent($input: CreateTrackingEventPublicInput!) {
    trackingEventsPublic {
      createTrackingEvent(input: $input) {
        error
        success
        entity {
          trackingEventId
          eventType
          event
          eventData
          accountId
          userProfileId
          createdDateTime
        }
      }
    }
  }
`;
